module.exports = __webpack_public_path__ + "static/media/flower.af506453.svg";